import { render, staticRenderFns } from "./AtividadePrintModal.vue?vue&type=template&id=156b9c7a&scoped=true"
import script from "./AtividadePrintModal.vue?vue&type=script&lang=js"
export * from "./AtividadePrintModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "156b9c7a",
  null
  
)

export default component.exports